import { default as empty } from "./empty.json";
import { default as metaMessage } from "./meta-message.json";

const data: { [key: string]: object } = {
  empty,
  metaMessage,
};

const shared = {
  getEmptyResponse: () => data["empty"],
  getMetaMessageResponse: () => data["metaMessage"],
};

export default shared;
